export const APPLY_COUPON = "APPLY_COUPON";
export const COUPON_ERROR = "COUPON_ERROR";
export const USER_COUPONS = "USER_COUPONS";
